import { Link } from 'react-router-dom';

const footerLinks = {
  热门分类: [
    { label: '热门剧集', path: '/category/drama' },
    { label: '电影大片', path: '/category/movie' },
    { label: '动漫番剧', path: '/category/anime' },
    { label: '综艺娱乐', path: '/category/variety' },
    { label: '纪录片', path: '/category/documentary' },
    { label: '少儿频道', path: '/category/kids' },
  ],
  帮助中心: [
    { label: '新手入门指南', path: '/article/baoyutv-xinshourumen' },
    { label: '会员权益详解', path: '/article/baoyutv-huiyuanquanyi' },
    { label: '离线下载教程', path: '/article/baoyutv-xiazaijiaocheng' },
    { label: '常见问题解答', path: '/article/baoyutv-changjianwenti' },
    { label: '最新入口地址', path: '/article/baoyutv-zuixindizhi' },
  ],
  关于我们: [
    { label: '品牌介绍', path: '/about' },
    { label: '联系方式', path: '/about#contact' },
    { label: '用户协议', path: '#' },
    { label: '隐私政策', path: '#' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="inline-block mb-4">
                <span className="font-heading text-2xl font-bold text-primary-400">
                  Baoyu<span className="text-background-100">TV</span>
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                BaoyuTV是备受用户青睐的高清视频平台，提供海量影视、综艺、动漫等优质内容资源。我们致力于为用户打造流畅、高清、纯净的观影体验。
              </p>
            </div>

            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h4 className="font-heading text-base font-semibold text-background-100 mb-4">{title}</h4>
                <ul className="space-y-2.5">
                  {links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; {new Date().getFullYear()} BaoyuTV. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-primary-400 hover:bg-background-700 transition-all duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-primary-400 hover:bg-background-700 transition-all duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-primary-400 hover:bg-background-700 transition-all duration-200 cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}